import { IdmDateRangePicker } from 'components/dateRangePicker/IdmDateRangePicker';
import useAgenciesDataStore from 'core/hooks/useAgenciesDataStore';
import useUrl from 'core/hooks/useUrl';
import DesignSelect from 'components/select/DesignSelect';
import { formatDate } from 'core/utils/DateUtils';
import useCouriersOverPeriodDataStore from '../../core/hooks/useCouriersWithItinerariesOverPeriodDataStore';

const ActivityFilter = () => {
  const { paramValue: dateRange, setParamValue: setDateRange } =
    useUrl<string[]>('DateRange');
  const { paramValue: selectedCouriers, setParamValue: setSelectedCouriers } =
    useUrl<number[]>('CourierId');
  const { paramValue: agencyParamValue, setParamValue: setAgencyParamValue } =
    useUrl<string>('AgencyId');
  const { agenciesData, areAgenciesLoading } = useAgenciesDataStore();
  const { couriers, areCourierLoading } = useCouriersOverPeriodDataStore(
    dateRange,
    agencyParamValue,
  );

  const onDateChanged = (start: Date, end: Date) => {
    setDateRange([formatDate(start), formatDate(end)]);
  };

  const handleAgencyChanged = ({ value }: any) => {
    setAgencyParamValue(value);
  };

  const onSelectedCouriersChanged = (
    selection: [{ value: number; label: string }] | [],
  ) => {
    setSelectedCouriers(selection.map((x) => x.value));
  };

  const agencies = agenciesData.map((x) => ({ value: x.id, label: x.name }));

  const courierIdsOptions = couriers?.map((x) => ({
    value: x.courierId,
    label: `${x.courierId} - ${x.indicative}`,
  }));
  return (
    <div>
      <IdmDateRangePicker
        onConfirmedDate={onDateChanged}
        fieldLabel="Select period"
      />
      <label
        className="mb-2 block text-xs font-bold uppercase tracking-wide"
        htmlFor="couriersSelect"
      >
        Agencies
      </label>
      <DesignSelect
        loading={areAgenciesLoading}
        options={agencies}
        onChange={handleAgencyChanged}
        value={agencies.filter((x) => x.value === agencyParamValue)}
      />
      <label
        className="mb-2 mt-4 block text-xs font-bold uppercase tracking-wide"
        htmlFor="couriersSelect"
      >
        Couriers
      </label>
      <DesignSelect
        isDisabled={!couriers}
        isLoading={areCourierLoading}
        options={courierIdsOptions}
        onChange={onSelectedCouriersChanged}
        isMulti
        closeMenuOnSelect={false}
        value={courierIdsOptions.filter(
          (x) => selectedCouriers?.includes(x.value),
        )}
      />
    </div>
  );
};

export default ActivityFilter;
